import React from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

class ButtonSave extends React.Component<React.HTMLProps<HTMLButtonElement> & InjectedIntlProps> {
    public render() {
        const { className, children, ...otherProps } = this.props;
        const newClassName = `btn btn-warning ${className}`;
        const newChildren = children ? children : this.props.intl.formatMessage({id: 'common.save'});
        return (
            <button className={newClassName} {...otherProps}>{newChildren}</button>
        );
    }
}

export default compose(
    injectIntl,
)(ButtonSave);



// WEBPACK FOOTER //
// ./src/components/Form/ButtonSave.tsx